import React, { useState, memo, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Page } from 'react-pdf';
import { pdfjs, Document } from 'react-pdf/dist/esm/entry.webpack';
import { Button } from '@material-ui/core';
import useMediaQueries from 'hooks/media-query-hooks';
import { LoaderSkeleton } from '../LoaderSkeleton';
import client from '../../../http/axios-client';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${ pdfjs.version }/pdf.worker.min.js`;

const PDFViewerHelper = memo(({ resp, numPages, setNumPages }) => {
  const onDocumentLoadSuccess = ({ numPages: newPages }) => {
    setNumPages(newPages);
  };

  const { isSm } = useMediaQueries();

  const width = window.innerWidth;

  return (
    <div style={ { height: '77vh', overflow: 'auto', width: '100%', margin: 0 } }>
      <div>
        <Document
          file={ { data: resp } }
          options={ { workerSrc: '/pdf.worker.js' } }
          onLoadSuccess={ onDocumentLoadSuccess }
          onLoadError={ console.error }
        >
          {
            Array.from(new Array(numPages), (el, index) => {
              return (
                <Page
                  pageNumber={ index + 1 }
                  width={ isSm ? width - 63 : width - 700 }
                  key={ `page_${ index + 1 }` }
                />
              );
            })
          }

        </Document>
      </div>
    </div>
  );
});

const PDFViewerMiddle = ({ serial, hasPDF }) => {
  const [ numPages, setNumPages ] = useState(null);

  const {
    data,
    isLoading,
  } = useQuery(
    [ 'pdf-viewer', serial, hasPDF ], () => {
      if (!hasPDF) {
        return null;
      }
      return client.get(`/readPDFFile?fileName=${ serial }.pdf`);
    },
  );

  if (!hasPDF) {
    return (
      <h1>Pdf not available</h1>
    );
  }

  if (isLoading) {
    return <LoaderSkeleton />;
  }

  const saveByteArray = () => {
    const u8 = new Uint8Array(data.Body.data);
    const blob = new Blob([ u8 ], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    const fileName = `Report (${ serial }).pdf`;
    link.download = fileName;
    link.click();
  };

  return (
    <div style={ { width: '100%' } }>
      <div style={ { display: 'flex', width: '100%', justifyContent: 'space-between', marginBottom: '1rem' } }>
        <h1>
          PDF
        </h1>
        <Button
          onClick={ saveByteArray }
          variant='contained'
          style={ { textTransform: 'none', color: 'white', background: '#648DAE' } }
        >
          Download
        </Button>
      </div>

      <PDFViewerHelper
        resp={ data.Body.data }
        numPages={ numPages }
        setNumPages={ setNumPages }
      />
    </div>
  );
};

const PDFViewer = ({ serial, pdfEx }) => {
  const [ hasPDF, setHasPDF ] = useState(false);

  const {
    data: kit,
    isLoading,
  } = useQuery(
    [ 'registration-kit-one', serial ],
    () => {
      return client.get(`registration-kits?serial_number_id.serial=${ serial }`);
    },
  );

  useEffect(() => {
    if (!isLoading) {
      setHasPDF(kit[0].pdf_available);
    }
  }, [ kit ]);

  if (isLoading) {
    return <LoaderSkeleton />;
  }

  return (
    <PDFViewerMiddle serial={ serial + pdfEx } hasPDF={ hasPDF } />
  );
};

export const FilePDFViewer = ({ path }) => {
  const [ numPages, setNumPages ] = useState(null);

  const onDocumentLoadSuccess = ({ numPages: newPages }) => {
    setNumPages(newPages);
  };

  const { isSm } = useMediaQueries();

  const width = window.innerWidth;

  return (
    <div style={ { height: '77vh', overflow: 'auto', width: '100%', margin: 0 } }>
      <div>
        <Document
          file={ path }
          options={ { workerSrc: '/pdf.worker.js' } }
          onLoadSuccess={ onDocumentLoadSuccess }
          onLoadError={ console.error }
        >
          {
            Array.from(new Array(numPages), (el, index) => {
              return (
                <Page
                  pageNumber={ index + 1 }
                  width={ isSm ? width - 63 : width - 720 }
                  key={ `page_${ index + 1 }` }
                />
              );
            })
          }

        </Document>
      </div>
    </div>
  );
};

PDFViewerHelper.displayName = 'PDFViewerHelper';
export default PDFViewer;
